<script setup lang="ts">
import { computed } from 'vue';
import { useEditorStore } from '@/stores/editor';
import { useMapStore } from '@/stores/map';

const editorStore = useEditorStore();
const mapStore = useMapStore();

const toolNames: Record<string, string> = {
    select: 'Select',
    paint_tile: 'Paint Tile',
    paint_object: 'Paint Object',
    erase_object: 'Erase Object',
    eyedropper: 'Eyedropper',
    bucket_fill: 'Bucket Fill',
    toggle_blocked: 'Toggle Blocked',
    toggle_teleport: 'Toggle Teleport',
    toggle_farming: 'Toggle Farming',
    toggle_buildable: 'Toggle Buildable',
};

const currentToolName = computed(() => toolNames[editorStore.currentTool] || 'Unknown');
</script>

<template>
    <footer class="status-bar">
        <div class="status-left">
            <span class="status-item" v-if="mapStore.hasMap">
                {{ mapStore.isDirty ? '*' : '' }}{{ mapStore.filename }}
            </span>
            <span class="status-item" v-if="mapStore.hasMap">
                Position: {{ editorStore.tileX >= 0 ? `${editorStore.tileX}, ${editorStore.tileY}` : '-' }}
            </span>
            <span class="status-item">
                Tool: {{ currentToolName }}
            </span>
            <span class="status-item">
                Brush: {{ editorStore.brushSize }}x{{ editorStore.brushSize }}
            </span>
        </div>
        <div class="status-right">
            <span class="status-item" v-if="mapStore.hasMap">
                Map: {{ mapStore.mapWidth }} x {{ mapStore.mapHeight }}
            </span>
            <span class="status-item">
                {{ Math.round(editorStore.zoom * 100) }}%
            </span>
        </div>
    </footer>
</template>

<style scoped>
.status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 24px;
    background: var(--bg-secondary);
    border-top: 1px solid var(--border-color);
    padding: 0 12px;
    font-size: 11px;
    color: var(--text-secondary);
}

.status-left,
.status-right {
    display: flex;
    gap: 16px;
}

.status-item {
    white-space: nowrap;
}
</style>
